import { AxiosError } from 'axios';
import { useQueryClient } from 'react-query';
import { PUT_CHANGE_PASSWORD } from '../../constants/apiUrls';
import { GET_USER_DETAILS_QUERY_KEY } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';

// =============================================================================
// Request & Response Model
// =============================================================================

export interface ChangePasswordRequest {
  oldPassword: string;
  newPassword: string;
  confirmedPassword: string;
}

export interface ChangePasswordResponse {}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: ChangePasswordResponse) => void;
  onError?: (err: AxiosError) => void;
}

export const usePutChangePassword = ({ onSuccess, onError }: Input) => {
  const queryClient = useQueryClient();
  const putChangePassword = async (payload: ChangePasswordRequest) => {
    const res = await axiosClient.put<ChangePasswordResponse>(PUT_CHANGE_PASSWORD, payload);
    return res.data;
  };

  return useCustomMutation(putChangePassword, {
    onSuccess: (res) => {
      queryClient.invalidateQueries([GET_USER_DETAILS_QUERY_KEY]);
      onSuccess?.(res);
    },
    onError,
  });
};
